import React from "react";
import { EditableArea } from "@magnolia/react-editor";

/**
 * Renders a Component Factory item, i.e. the page behind one reusable component.
 *
 * Mapped to the headless factory page template. Deliberately thin: an item is a fragment
 * meant to be embedded elsewhere, not a page of its own, so it gets no HtmlHeader, no
 * navigation and no footer. What surrounds it here is whatever the storefront's BaseLayout
 * renders, which is the point of previewing it in this app rather than in a generic shell.
 *
 * The area stays editable, so the Pages app draws its bars over it. That works because the
 * template annotations come from the endpoint for this workspace; without that endpoint the
 * item renders but nothing in it can be selected.
 */
const ComponentFactoryItem = ({ main }) => (
    <div className="component-factory-item">{main && <EditableArea content={main} />}</div>
);

export default ComponentFactoryItem;
